import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  opened: false,
  options: null,
  onChange: null,
  placeHolder: null,
  selectedOption: null,
};

const selectSlice = createSlice({
  name: 'select',
  initialState,
  reducers: {
    openSelect: (state, action) => {
      state.opened = true;
      state.options = action.payload.options;
      state.onChange = action.payload.onChange;
      state.placeHolder = action.payload.placeHolder;
      state.selectedOption = action.payload.selectedOption;
    },
    closeSelect: (state) => {
      state.opened = false;
      state.options = [];
      state.onChange = () => {};
      state.placeHolder = null;
      state.selectedOption = null;
    },
  },
});

export const { openSelect, closeSelect } = selectSlice.actions;

export const selectOpened = (state) => state.select.opened;
export const selectPlaceHolder = (state) => state.select.placeHolder;
export const selectOptions = (state) => state.select.options;
export const selectSelectedOption = (state) => state.select.selectedOption;
export const selectOnChange = (state) => state.select.onChange;

export default selectSlice.reducer;
